import React from 'react';

import { useIntl } from 'react-intl';
import WizardPageLayout from '~/ui/components/WizardPageLayout/WizardPageLayout';

import WorkflowTemplatesList from './WorkflowTemplatesList';

const WizardWorkflowTemplatesList = (props) => {
  const intl = useIntl();

  const steps = [
    intl.formatMessage({
      id: 'WizardWorkflowTemplatesList.selectWorkflowStep',
      defaultMessage: 'Select Workflow',
      description: 'First step in the wizard process',
    }),
    intl.formatMessage({
      id: 'WizardWorkflowTemplatesList.createTicketStep',
      defaultMessage: 'Create Ticket',
      description: 'Second step in the wizard process',
    }),
    intl.formatMessage({
      id: 'WizardWorkflowTemplatesList.takeActionStep',
      defaultMessage: 'Take Action',
      description: 'Third step in the wizard process',
    }),
  ];

  return (
    <WizardPageLayout
      currentStep={intl.formatMessage({
        id: 'WizardWorkflowTemplatesList.currentStep',
        defaultMessage: 'Select Workflow',
        description: 'Current step label in the wizard',
      })}
      steps={steps}
      title={intl.formatMessage({
        id: 'WizardWorkflowTemplatesList.title',
        defaultMessage: 'New Ticket',
        description: 'Title of the wizard page',
      })}
      onClose={props.hideModal}
    >
      <WorkflowTemplatesList {...props} />
    </WizardPageLayout>
  );
};

export default WizardWorkflowTemplatesList;
